// @generated
// @generator packages/ml-webclient-styleguide/tools/rubiks/theme-generator

/* eslint-disable simple-import-sort/imports */
import { ThemeOptions } from '@mui/material/styles';

import { enumType, makeEnum } from '../utils';

import * as theme0 from './generated/magicline.json';
import * as theme1 from './generated/planet-fitness.json';
import * as theme2 from './generated/perfect-leisure.json';
import * as theme3 from './generated/perfect-gym-next.json';
import * as theme4 from './generated/pgn-light-top-navigation.json';
import * as theme5 from './generated/magicline-v2.json';

export type ThemeName =
    | 'magicline'
    | 'planet-fitness'
    | 'perfect-leisure'
    | 'perfect-gym-next'
    | 'pgn-light-top-navigation'
    | 'magicline-v2';

export const DefaultColor = makeEnum(
    'primary',
    'secondary',
    'error',
    'warning',
    'info',
    'success'
);
export type DefaultColor = enumType<typeof DefaultColor>;

export type ColorToken =
    | 'light'
    | 'dark'
    | 'main'
    | 'contrastText'
    | 'inverseText';

export const Palette = makeEnum(
    'action.active',
    'action.disabled',
    'action.disabled-background',
    'action.focus',
    'action.hover',
    'action.selected',
    'background.default',
    'background.paper',
    'components.alert.error.background',
    'components.alert.error.color',
    'components.alert.info.background',
    'components.alert.info.color',
    'components.alert.success.background',
    'components.alert.success.color',
    'components.alert.warning.background',
    'components.alert.warning.color',
    'components.app-bar.default-fill',
    'components.avatar.active-border',
    'components.avatar.avatar',
    'components.avatar.desaturate',
    'components.avatar.disabled',
    'components.avatar.fill',
    'components.avatar.icon',
    'components.backdrop.fill',
    'components.breadcrumbs.collapse-fill',
    'components.chip.app.contrastText',
    'components.chip.app.focused',
    'components.chip.app.hovered',
    'components.chip.app.main',
    'components.chip.default.contrastText',
    'components.chip.default.focused',
    'components.chip.default.hovered',
    'components.chip.default.main',
    'components.chip.digital-post.contrastText',
    'components.chip.digital-post.focused',
    'components.chip.digital-post.hovered',
    'components.chip.digital-post.main',
    'components.chip.error.contrastText',
    'components.chip.error.focused',
    'components.chip.error.hovered',
    'components.chip.error.main',
    'components.chip.info.contrastText',
    'components.chip.info.focused',
    'components.chip.info.hovered',
    'components.chip.info.main',
    'components.chip.letter.contrastText',
    'components.chip.letter.focused',
    'components.chip.letter.hovered',
    'components.chip.letter.main',
    'components.chip.mail.contrastText',
    'components.chip.mail.focused',
    'components.chip.mail.hovered',
    'components.chip.mail.main',
    'components.chip.message.contrastText',
    'components.chip.message.focused',
    'components.chip.message.hovered',
    'components.chip.message.main',
    'components.chip.primary.contrastText',
    'components.chip.primary.focused',
    'components.chip.primary.hovered',
    'components.chip.primary.main',
    'components.chip.selectable.active',
    'components.chip.selectable.contrast-text-active',
    'components.chip.selectable.contrastText',
    'components.chip.selectable.focused',
    'components.chip.selectable.hovered',
    'components.chip.selectable.main',
    'components.chip.success.contrastText',
    'components.chip.success.focused',
    'components.chip.success.hovered',
    'components.chip.success.main',
    'components.chip.warning.contrastText',
    'components.chip.warning.focused',
    'components.chip.warning.hovered',
    'components.chip.warning.main',
    'components.content.border-radius',
    'components.content.fill',
    'components.content.outline',
    'components.data-grid.group-row',
    'components.data-grid.striped',
    'components.facility.background.enabled',
    'components.facility.background.focus',
    'components.facility.background.hover',
    'components.facility.background.inactive',
    'components.facility.background.selected',
    'components.facility.contrast.arrow',
    'components.facility.contrast.icon',
    'components.facility.contrast.icon-inactive',
    'components.facility.contrast.outlined-border',
    'components.facility.contrast.text',
    'components.facility.contrast.text-inactive',
    'components.facility.contrast.text-top-navigation',
    'components.facility.input.line',
    'components.filter-textfield.enabled.bg',
    'components.filter-textfield.enabled.icon',
    'components.filter-textfield.enabled.text',
    'components.filter-textfield.error.bg',
    'components.filter-textfield.error.border',
    'components.filter-textfield.error.icon',
    'components.filter-textfield.error.value',
    'components.filter-textfield.filled.bg',
    'components.filter-textfield.filled.icon',
    'components.filter-textfield.filled.value',
    'components.filter-textfield.focused.bg',
    'components.filter-textfield.focused.border',
    'components.filter-textfield.focused.icon',
    'components.filter-textfield.focused.placeholder',
    'components.filter-textfield.hover.bg-hover',
    'components.filter-textfield.hover.border',
    'components.input.color',
    'components.input.filled.enabled-fill',
    'components.input.filled.hover-fill',
    'components.input.outlined.enabled-border',
    'components.input.outlined.hover-border',
    'components.input.standard.enabled-border',
    'components.input.standard.hover-border',
    'components.language-picker.background.enabled',
    'components.language-picker.background.focus',
    'components.language-picker.background.hover',
    'components.language-picker.contrast.arrow',
    'components.language-picker.contrast.icon',
    'components.language-picker.contrast.text',
    'components.language-picker.input.line',
    'components.language-picker.input.text',
    'components.messages.default.receiver.contrastText',
    'components.messages.default.receiver.main',
    'components.messages.default.receiver.outlined-border',
    'components.messages.default.sender.contrastText',
    'components.messages.default.sender.main',
    'components.messages.default.sender.outlined-border',
    'components.messages.error.contrastText',
    'components.messages.error.main',
    'components.messages.error.outlined-border',
    'components.messages.warning.contrastText',
    'components.messages.warning.main',
    'components.messages.warning.outlined-border',
    'components.rating.active-fill',
    'components.rating.enabled-border',
    'components.segment-control.background',
    'components.segment-control.background-active',
    'components.segment-control.icon-default',
    'components.segment-control.label-active',
    'components.side-navigation.background',
    'components.side-navigation.divider',
    'components.side-navigation.focus',
    'components.side-navigation.header.font.default',
    'components.side-navigation.hover',
    'components.side-navigation.icon.default',
    'components.side-navigation.item.font.active',
    'components.side-navigation.item.font.default',
    'components.side-navigation.selected',
    'components.simple-select.primary.border-active',
    'components.simple-select.primary.closed.bg',
    'components.simple-select.primary.closed.bg-hover',
    'components.simple-select.primary.closed.bg-ripple',
    'components.simple-select.primary.closed.icon-default',
    'components.simple-select.primary.closed.label-default',
    'components.simple-select.primary.closed.label-default-2',
    'components.simple-select.primary.closed.label-default-3',
    'components.simple-select.primary.opened.bg',
    'components.simple-select.primary.opened.bg-hover',
    'components.simple-select.primary.opened.bg-ripple',
    'components.simple-select.primary.opened.label-active',
    'components.simple-select.primary.opened.label-hover',
    'components.simple-select.secondary.border-active',
    'components.simple-select.secondary.closed.bg',
    'components.simple-select.secondary.closed.bg-hover',
    'components.simple-select.secondary.closed.bg-ripple',
    'components.simple-select.secondary.closed.icon-default',
    'components.simple-select.secondary.closed.label-default',
    'components.simple-select.secondary.opened.bg',
    'components.simple-select.secondary.opened.bg-hover',
    'components.simple-select.secondary.opened.label-active',
    'components.simple-select.secondary.opened.label-hover',
    'components.snackbar.fill',
    'components.stepper.connector',
    'components.stepper.contrast',
    'components.stepper.default',
    'components.stepper.done',
    'components.stepper.swipe',
    'components.switch.knob-fill-enabled',
    'components.switch.know-fill-disabled',
    'components.switch.slide-fill',
    'components.tab.primary.bg-active-vertical',
    'components.tab.primary.font',
    'components.tab.primary.font-active',
    'components.tab.secondary.bg-active',
    'components.tab.secondary.font',
    'components.tab.secondary.font-active',
    'components.tooltip.fill',
    'components.top-navigation.badge',
    'components.top-navigation.font',
    'components.top-navigation.icon',
    'components.tree-elevation-base',
    'components.tree-elevation-overlay',
    'divider',
    'error',
    'error._states.focus',
    'error._states.focus-visible',
    'error._states.hover',
    'error._states.outlined-border',
    'error._states.selected',
    'error.contrastText',
    'error.dark',
    'error.inverseText',
    'error.light',
    'error.main',
    'info',
    'info._states.focus',
    'info._states.focus-visible',
    'info._states.hover',
    'info._states.outlined-border',
    'info._states.selected',
    'info.contrastText',
    'info.dark',
    'info.inverseText',
    'info.light',
    'info.main',
    'inherit',
    'primary',
    'primary._states.focus',
    'primary._states.focus-visible',
    'primary._states.hover',
    'primary._states.outlined-border',
    'primary._states.selected',
    'primary.contrastText',
    'primary.dark',
    'primary.inverseText',
    'primary.light',
    'primary.main',
    'secondary',
    'secondary._states.focus',
    'secondary._states.focus-visible',
    'secondary._states.hover',
    'secondary._states.outlined-border',
    'secondary._states.selected',
    'secondary.contrastText',
    'secondary.dark',
    'secondary.inverseText',
    'secondary.light',
    'secondary.main',
    'success',
    'success._states.focus',
    'success._states.focus-visible',
    'success._states.hover',
    'success._states.outlined-border',
    'success._states.selected',
    'success.contrastText',
    'success.dark',
    'success.inverseText',
    'success.light',
    'success.main',
    'text.disabled',
    'text.primary',
    'text.secondary',
    'warning',
    'warning._states.focus',
    'warning._states.focus-visible',
    'warning._states.hover',
    'warning._states.outlined-border',
    'warning._states.selected',
    'warning.contrastText',
    'warning.dark',
    'warning.inverseText',
    'warning.light',
    'warning.main'
);
export type Palette = enumType<typeof Palette>;

export const TypographyToken = makeEnum(
    'components._library.heading.fontSize',
    'components._library.heading.fontWeight',
    'components.alert.description.fontSize',
    'components.alert.description.fontWeight',
    'components.alert.title.fontSize',
    'components.alert.title.fontWeight',
    'components.avatar.initials-lg.fontSize',
    'components.avatar.initials-lg.fontWeight',
    'components.avatar.initials-md.fontSize',
    'components.avatar.initials-md.fontWeight',
    'components.avatar.initials-sm.fontSize',
    'components.avatar.initials-sm.fontWeight',
    'components.badge.label-medium.fontSize',
    'components.badge.label-medium.fontWeight',
    'components.badge.label.fontSize',
    'components.badge.label.fontWeight',
    'components.bottom-navigation.active-label.fontSize',
    'components.bottom-navigation.active-label.fontWeight',
    'components.button.large.fontSize',
    'components.button.large.fontWeight',
    'components.button.medium.fontSize',
    'components.button.medium.fontWeight',
    'components.button.small.fontSize',
    'components.button.small.fontWeight',
    'components.chip.medium.fontSize',
    'components.chip.medium.fontWeight',
    'components.chip.small.fontSize',
    'components.chip.small.fontWeight',
    'components.data-grid.aggregation-column-header-label.fontSize',
    'components.data-grid.aggregation-column-header-label.fontWeight',
    'components.date-picker.current-month.fontSize',
    'components.date-picker.current-month.fontWeight',
    'components.filter-textfield.fontWeight',
    'components.input.helper.fontSize',
    'components.input.helper.fontWeight',
    'components.input.label.fontSize',
    'components.input.label.fontWeight',
    'components.input.valuer-big.fontSize',
    'components.input.valuer-big.fontWeight',
    'components.input.valuer-small.fontSize',
    'components.input.valuer-small.fontWeight',
    'components.input.valuer.fontSize',
    'components.input.valuer.fontWeight',
    'components.list.subheader.fontSize',
    'components.list.subheader.fontWeight',
    'components.menu.header-active.fontSize',
    'components.menu.header-active.fontWeight',
    'components.menu.item-active.fontSize',
    'components.menu.item-active.fontWeight',
    'components.menu.item-default.fontSize',
    'components.menu.item-default.fontWeight',
    'components.menu.item-dense.fontSize',
    'components.menu.item-dense.fontWeight',
    'components.stepper.active.fontSize',
    'components.stepper.active.fontWeight',
    'components.stepper.inactive.fontSize',
    'components.stepper.inactive.fontWeight',
    'components.stepper.success.fontSize',
    'components.stepper.success.fontWeight',
    'components.table.header.fontSize',
    'components.table.header.fontWeight',
    'components.tooltip.label.fontSize',
    'components.tooltip.label.fontWeight'
);
export type TypographyToken = enumType<typeof TypographyToken>;

export const ChipColor = makeEnum(
    'selectable',
    'default',
    'primary',
    'error',
    'warning',
    'success',
    'info',
    'mail',
    'letter',
    'message',
    'digital-post',
    'app'
);
export type ChipColor = enumType<typeof ChipColor>;

export default {
    magicline: theme0 as ThemeOptions,
    'planet-fitness': theme1 as ThemeOptions,
    'perfect-leisure': theme2 as ThemeOptions,
    'perfect-gym-next': theme3 as ThemeOptions,
    'pgn-light-top-navigation': theme4 as ThemeOptions,
    'magicline-v2': theme5 as ThemeOptions
};
